import React, { useState } from "react";

import { Box, FormHelperText, InputLabel } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useFormikContext } from "formik";
import { get } from "lodash";
import { useTheme } from "@mui/material/styles";

function TextArea({
  id,
  name,
  label,
  autoComplete = "off",
  sx,
  onBlur,
  onChange,
  width,
  required,
  value,
  inputSx,
  rows,
  ...params
}) {
  const { errors, values, touched, submitCount } = useFormikContext();
  const error = get(errors, name);
  const fieldTouched = get(touched, name);
  const theme = useTheme();
  
  const textAreaStyle = {
    width: "100%",
    background: "transparent",
    border: "none",
    boxShadow: "none",
    "& .MuiOutlinedInput-input": {
      position: "relative",
      zIndex: 1,
    },
  
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: "6px",
      width: '100%',
  
      margin: "none",
      padding: "0px",
      textAlign: "center",
      background: "#FFF",
  
      "&:hover fieldset": {
        borderColor: `${theme.palette.primary.main}`,
      },
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .MuiOutlinedInput-root:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: `${theme.palette.primary.main}`,
      },
    },
    "& .MuiOutlinedInput-root": {
      width: "100%",
      "&.Mui-focused fieldset": {
        borderColor:`${theme.palette.primary.main}`,
      },
    },
    "& .input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active":
      {
        transition: "background-color 5000s ease-in-out 0s",
        background: `${theme.palette.primary.main} !important`,
        color: "black !important",
        padding: "0px 14px  !important",
        appearance: "none  !important",
    },
    
    "@media (max-width: 600px)": {
      width: "98%"
    },
  };

  return (
    <>
      <TextField
        id={id}
        name={name}
        label=""
        multiline
        rows={rows}
        // autoComplete="off"
        variant="outlined"
        sx={{ ...textAreaStyle, ...sx }}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={fieldTouched && error}
        {...params}
      />
    </>
  );
}

export default TextArea;


